import { render } from "./HowToMain.vue?vue&type=template&id=0d3e4f58&scoped=true"
import script from "./HowToMain.vue?vue&type=script&lang=js"
export * from "./HowToMain.vue?vue&type=script&lang=js"

import "./HowToMain.vue?vue&type=style&index=0&id=0d3e4f58&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d3e4f58"]])

export default __exports__